import { RootState } from "src/store/store";

/**
 *
 */
export namespace InsuranceVehicleSelector {
  
  export const isPicturesCompleted = (state: RootState) => state.insuranceVehicle?.isPicturesCompleted;

}